import { render, staticRenderFns } from "./VideoCardContent.vue?vue&type=template&id=32b88758&"
import script from "./VideoCardContent.vue?vue&type=script&lang=ts&"
export * from "./VideoCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports